import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";

import avatar from "../../public/images/team/team-01.jpg";

import UserMenuItems from "../Header/HeaderProps/UserMenuItems";

import HeaderData from "../../data/header.json";
import { useAppContext } from "@/context/Context";
import { useUserContext } from "@/context/UserContext";

import dynamic from 'next/dynamic';
const LeftPanelUserDetails = dynamic(() => import('./LeftPanelUserDetails'), { ssr: false });

const LeftpanelDashboard = () => {
  const router = useRouter();
  const { shouldCollapseLeftbar } = useAppContext();
  const { userInfo, userLoggedIn} = useUserContext();

  console.log(userInfo);
  console.log(userLoggedIn)

  const isActive = (href) => router.pathname === href;

  return (
    <>
      <div
        className={`rbt-left-panel popup-dashboardleft-section ${
          shouldCollapseLeftbar ? "collapsed" : ""
        }`}
      >
        <div className="rbt-default-sidebar">
          <div className="inner">
            <div className="content-item-content">
              <div className="rbt-default-sidebar-wrapper">
                <nav className="mainmenu-nav">
                  <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                    <li>
                      <Link
                        className={isActive("/") ? "active" : ""}
                        href="/"
                      >
                        <i className="feather-home"></i>
                        <span>Welcome</span>
                      </Link>
                    </li>
                    <li>
                      {userLoggedIn ? (
                      <Link
                        className={isActive("/plans-billing") ? "active" : ""}
                        href="/plans-billing"
                      >
                        <i className="feather-dollar-sign"></i>
                        <span>Manage Subscription</span>
                      </Link>
                      ) : (
                        <Link
                        className={isActive("/SignUp") ? "active" : ""}
                        href="/SignUp"
                      >
                        <i className="feather-user"></i>
                        <span>Sign Up</span>
                      </Link>
                      )}
                    </li>
                  </ul>
                  <div className="rbt-sm-separator"></div>
                  <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                    {HeaderData &&
                      HeaderData.leftPanel.slice(0, 7).map((data, index) => (
                        <li key={index}>
                          <Link
                            href={data.link}
                            className={
                              isActive(data.link)
                                ? "active"
                                : `${data.isDisable ? "disabled" : ""}`
                            }
                          >
                            <Image
                              src={data.img}
                              width={35}
                              height={35}
                              alt="AI Generator"
                            />
                            <span>{data.title}</span>
                            {data.smallBadge !== "" ? (
                              <div className="jureeltd-badge-card badge-sm ml--10">
                                {data.smallBadge}
                              </div>
                            ) : (
                              ""
                            )}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </nav>

                <div className="rbt-sm-separator"></div>

                <nav className="mainmenu-nav">
                <ul className="dashboard-mainmenu rbt-default-sidebar-list">
    <UserMenuItems parentClass="rbt-default-sidebar-list" />
  </ul>
                  <div className="rbt-sm-separator"></div>
                  <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                    {/* <li>
                      <Link
                        className={isActive("/release-notes") ? "active" : ""}
                        href="/release-notes"
                      >
                        <i className="feather-bell"></i>
                        <span>Release notes</span>
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        className={isActive("/terms-of-use") ? "active" : ""}
                        href="/terms-of-use"
                      >
                        <i className="feather-paperclip"></i>
                        <span>Terms of Use</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={isActive("/privacy-policy") ? "active" : ""}
                        href="/privacy-policy"
                      >
                        <i className="feather-paperclip"></i>
                        <span>Privacy Policy</span>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              
            </div>
            {userLoggedIn && (
                <LeftPanelUserDetails />
              )}
          </div>
          
          
          <p className="subscription-copyright copyright-text text-center b4  small-text">
            © 2024
            <Link
              className="ps-2"
              href=""
            >
              Juree AI
            </Link>
            .
          </p>
        </div>
      </div>
    </>
  );
};

export default LeftpanelDashboard;
